import { authHeaders, getAuthToken } from "../../store/authStore";
import { getApiBaseUrl } from "../../store/workspaceStore";
import { parseProfile } from "./helpers";
import type { DemoSeedProfile } from "./types";

export async function fetchDemoSeedProfile(): Promise<DemoSeedProfile | null> {
  if (getAuthToken() === null) return null;
  const response = await fetch(`${getApiBaseUrl()}/api/me/profile`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("profile request failed");
  return parseProfile(await response.json());
}

export async function retryDemoSeed(): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/api/me/demo-seed/retry`, {
    method: "POST",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("retry failed");
}

export async function acknowledgeDemoWelcome(): Promise<void> {
  const response = await fetch(
    `${getApiBaseUrl()}/api/me/demo-welcome/acknowledge`,
    {
      method: "POST",
      headers: authHeaders(),
    },
  );
  if (!response.ok) throw new Error("acknowledgement failed");
}
